// extracted by mini-css-extract-plugin
export default {"cardWrapper":"GraphCard_cardWrapper__AVUb2"};